import { useCallback } from 'react';

import type { EditorActions } from '@atlaskit/editor-core';
import type { Provider, CollabEditProvider, ResolvedEditorState } from '@atlaskit/collab-provider';

type UseGetCollabProviderStateProps = {
	editorActions: EditorActions;
	collabEditProvider: (CollabEditProvider & Provider) | null;
	forceAwaitCommitLocalSteps?: boolean;
};

export const useGetCollabProviderState = ({
	editorActions,
	collabEditProvider,
	forceAwaitCommitLocalSteps = false,
}: UseGetCollabProviderStateProps): ((
	awaitCommitLocalSteps?: boolean,
) => Promise<ResolvedEditorState | undefined> | undefined) => {
	// awaitCommitLocalSteps dictates whether we wait until all the user's local steps are committed to collab-service backend before
	// returning the document, or if we return document immediately
	return useCallback(
		(awaitCommitLocalSteps = true) => {
			return awaitCommitLocalSteps || !!forceAwaitCommitLocalSteps
				? editorActions.getResolvedEditorState()
				: collabEditProvider?.getCurrentState();
		},
		[editorActions, collabEditProvider, forceAwaitCommitLocalSteps],
	);
};
